export const BUILD_VERSION = '15.0.0-20250917-1232';
